import React, { useRef } from 'react';
import { ActivityIndicator, } from 'react-native';
import { Button } from '@rneui/themed';
import BottomSheet, { BottomSheetFlatList } from '@gorhom/bottom-sheet';
import { Icon } from '@rneui/themed';
import { Portal } from '@gorhom/portal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '../../../hooks';
import { ChapterItem } from './';
import { BottomSheetBackdrop, useChapterData } from '../../..';
import { TextTicker } from '../../shared';
export const UnmemoizedChapterList = ({ chapters, onPressChapter = () => { }, size, buttonStyle, iconStyle, }) => {
    const { top, bottom } = useSafeAreaInsets();
    const { colors } = useTheme();
    const bottomSheetRef = useRef(null);
    const { chapterLengthMap, chapterLocation, } = useChapterData(chapters);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "clear", onPress: () => bottomSheetRef.current?.snapToIndex(0), style: buttonStyle, containerStyle: { maxWidth: '100%' } },
            React.createElement(Icon, { name: "list", style: iconStyle || undefined, size: size }),
            chapterLocation
                ? React.createElement(TextTicker, null, chapterLocation.current.name)
                : React.createElement(ActivityIndicator, null)),
        React.createElement(Portal, { hostName: "modal" },
            React.createElement(BottomSheet, { ref: bottomSheetRef, backdropComponent: BottomSheetBackdrop, index: -1, topInset: top, enablePanDownToClose: true, enableDynamicSizing: false, snapPoints: ['75%', '100%'], backgroundStyle: { backgroundColor: colors.backgroundPrimary }, handleIndicatorStyle: { backgroundColor: colors.textPrimary }, containerStyle: { zIndex: 3000 } },
                React.createElement(BottomSheetFlatList, { contentContainerStyle: { paddingBottom: bottom }, data: chapterLengthMap, keyExtractor: (item) => item.id.toString(), renderItem: ({ item: chapter }) => (React.createElement(ChapterItem, { active: chapter.id === chapterLocation?.current?.id, chapter: chapter, onPress: (loc) => {
                            onPressChapter(loc);
                            bottomSheetRef.current?.close();
                        } })) })))));
};
export const ChapterList = React.memo(UnmemoizedChapterList, (prev, next) => {
    return prev.chapters?.[0].id === next.chapters?.[0].id &&
        prev.size === next.size;
});
//# sourceMappingURL=ChapterList.js.map